// note: keep in-sync with rust-shared/src/utils/db_constants.rs

// hard-coded UUIDs (22-chars, matching regular uuids/slug-ids)
// ==========

export const systemUserID =		"DM_SYSTEM_000000000001";
export const systemUserName =		"[system]";
export const systemUserEmail =	"debatemap@gmail.com";

export const systemPolicy_publicUngoverned_name = "Public, ungoverned (standard)";
export const systemPolicy_publicGoverned_name = "Public, governed (standard)";
export const systemPolicy_privateGoverned_name = "Private, governed (standard)";

export const globalMapID =			"GLOBAL_MAP_00000000001";
export const globalRootNodeID =	"GLOBAL_ROOT_0000000001";